// extracted by mini-css-extract-plugin
export default {"button":"D9rCdbkzbPEYlTwSET5t"};